// ********
// Quantity Counter
// ********

const addRemoveQuantityCounterButton = (element, toggle) => {
  const parentElem = element.closest('.quantity-counter');
  const inputElem = parentElem.querySelector('.quantity-counter__input');
  const minusButton = parentElem.querySelector('.quantity-counter__button--remove');
  const plusButton = parentElem.querySelector('.quantity-counter__button--add');
  let currentVal = parseInt(inputElem.value, 10);

  if (currentVal >= 1) {
    // eslint-disable-next-line
    inputElem.value = toggle ? ++currentVal : --currentVal;
    minusButton.classList.remove('is-disabled');
  }

  if (currentVal === 1) {
    minusButton.classList.add('is-disabled');
  }
  if (inputElem.max) {
    plusButton.classList.toggle('is-disabled', parseInt(inputElem.max) === parseInt(inputElem.value));
  }
};

attachEvent('.quantity-counter__button--add', 'click', (ev) => {
  addRemoveQuantityCounterButton(ev.target, true);
});

attachEvent('.quantity-counter__button--remove', 'click', (ev) => {
  addRemoveQuantityCounterButton(ev.target, false);
});

// ********
// Counter Disabled Class
// ********

const quantityCounterEle = document.querySelectorAll('.quantity-counter');

if (quantityCounterEle.length > 0) {
  quantityCounterEle.forEach((el) => {
    const inputElem = el.querySelector('.quantity-counter__input');
    const minusButton = el.querySelector('.quantity-counter__button--remove');
    const plusButton = el.querySelector('.quantity-counter__button--add');
    const currentVal = parseInt(inputElem.value, 10);
    if (currentVal > 1) {
      minusButton.classList.remove('is-disabled');
    }
    if (currentVal === 1 && inputElem.max) {
      plusButton.classList.toggle('is-disabled', parseInt(inputElem.max) === parseInt(inputElem.value));
    }
  });
}
